export const homeFaqs = [
  {
    order: 0,
    anchor: null,
    title: 'What is Quashed and how does it work?',
    content:
      'Quashed.co.nz is NZ’s first and fastest growing online insurance platform that enables consumers to compare, shop and track all their insurance in one place. As of March 2025, more than 60,000 NZ consumers have signed up to shop and save on their insurance with us. Once you’ve signed up for free, you enter your information once on Market Scan and you’ll receive comparison showing a range of insurance across several different insurance companies in a couple of minutes. You can also load up all your existing insurance to see how much you’re spending, and if you can save money on your insurance. It’s quick, easy and secure.',
  },
  {
    order: 1,
    anchor: null,
    title: 'Why compare insurance in NZ?',
    content:
      'Comparisons help consumers make better decisions. Like most things we buy, we want to know if we are getting a good deal and if the product/service is suitable for us. Comparing insurance helps us to know this. The cost of insurance can vary a lot across different insurance companies and so can their policy benefits. On average (based on Q1 2025 Quashed Market Scan data), our users found savings of $370 on car insurance, $485 on house insurance and $285 on contents insurance. In our lifetime, we will likely spend more than $100,000 on insurance. Comparing and saving even just 20% on your insurance can make a huge difference over the years adding up to tens of thousands of dollars.',
  },
  {
    order: 2,
    anchor: null,
    title: 'What insurance can I compare on Quashed?',
    content:
      'You can compare car insurance, house insurance, contents insurance, landlord insurance, motorcycle insurance, and life insurance on Quashed. Other insurance such as pet insurance, travel insurance, and more will be available to compare in time.',
  },
  {
    order: 3,
    anchor: null,
    title: 'How much can I save comparing my insurance?',
    content:
      'Some Quashed users have saved more than $1,000 just by shopping their car insurance with us. Others may have saved upwards of $2,000 or more when shopping multiple car insurance, house insurance and contents insurance policies. Many have saved a few hundred dollars. Some users will find that their existing insurance policy is cheaper than the options we can find them - so they are happy to learn that. ',
  },
  {
    order: 4,
    anchor: null,
    title:
      'Can Quashed find me the cheapest insurance and best insurance policy?',
    content:
      'That’s our goal. To find and display a wide range of options so you can choose to buy the cheapest and/or the best insurance policy for you. The cost of insurance can vary a lot across insurance companies. For the same car, one insurance company may charge $800 for a comprehensive and another may charge $1,600. Our hope is to make it easy for you to find the cheapest and the best insurance policy in the market.',
  },
  {
    order: 5,
    anchor: null,
    title: 'Do you compare all insurance providers in NZ?',
    content:
      'We compare the widest range of insurance providers at Quashed, but not all. There are more than 30+ insurance companies and brands in New Zealand. While our desire is to work with all of them, not all insurance companies are open to being compared. We are constantly working to bring on more insurance companies onto the platform so check back in from time to time for more options.',
  },
  {
    order: 6,
    anchor: null,
    title: 'Does it cost more to buy insurance via Quashed?',
    content:
      'No. We do not add on any fees nor charges to the prices you see. The price you see on Quashed and end up paying for a policy should be the same when you go directly to the insurers’ website. As long as the information used is the same (e.g. sum insured, excess, accident history, age). If you find any discrepancies, let us know and we’ll take a look at it for you.',
  },
  {
    order: 7,
    anchor: null,
    title: 'Is Quashed an insurance adviser or insurance broker?',
    content:
      'While we hold a FAP license, we do not provide advice on any insurance products on the platform. We make information easily accessible and transparent on Quashed which help consumers to make better decisions. We also do not charge any fees which brokers and advisers some times charge (which can range anywhere from $50 to $500).',
  },
  {
    order: 8,
    anchor: null,
    title: 'Is Quashed a NZ company?',
    content:
      'Quashed is a NZ owned, Auckland based company. We count some of NZ’s most well known investors and companies such as Icehouse Ventures and Turners Automotive Group (Turners) as our shareholders.',
  },
  {
    order: 9,
    anchor: null,
    title: 'Does Quashed charge consumers and how does it make money?',
    content:
      'Quashed is free to sign up and use for consumers. We earn money in a similar way as insurance brokers and advisers, when you purchase a policy via our platform. Please show your support and keep this platform online by clicking through to the insurance provider you are looking to purchase your policy from.',
  },
];
